import { render, staticRenderFns } from "./ReviewsCategoriesCard.vue?vue&type=template&id=e083d488&scoped=true&"
import script from "./ReviewsCategoriesCard.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesCard.vue?vue&type=style&index=0&id=e083d488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e083d488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
